import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';

import { AppGlobals } from '../../app.globals';
import { FeatureFlags } from '../../interfaces/enums/feature-flag';

/**
 * Keeps a page behind a tenant feature flag out of reach by URL, not only out of the menu.
 *
 * Waits for the flags like adminGuard waits for the permissions: on a cold deep link the guard
 * runs before app.component.setTenantId() has loaded them, and an empty map would bounce a
 * tenant that has the feature on. AppGlobals.features stays undefined until they are loaded.
 */
export const featureGuard =
  (flag: FeatureFlags): CanActivateFn =>
  async () => {
    const router = inject(Router);
    const appGlobals = inject(AppGlobals);

    await firstValueFrom(appGlobals.$features.pipe(filter(() => AppGlobals.features != null)));

    return AppGlobals.UserCan(flag) || router.createUrlTree(['/']);
  };
